// src/pages/SwitchCalendarPage.jsx

import React from "react";
import { Box } from "@mui/material";
import PageHeader from "../components/ui/PageHeader";
import SwitchCalendarView from "../components/switchCalendar/SwitchCalendarView";

const SwitchCalendarPage = () => {
  return (
    <Box>
      <PageHeader
        title="Calendario de cambios de comercializadora"
        subtitle="Recordatorios de cambio de comercializadora"
      />
      <SwitchCalendarView />
    </Box>
  );
};

export default SwitchCalendarPage;